export default "__VITE_ASSET__4NZccL59__"